const methods = {
    issueHasChanges(issue) {
        this.$set(this, 'issue', issue);
    }
};

export default methods;
